module.exports = __webpack_public_path__ + "img/icon-optional-view@3x.efce269b.png";